import { Type } from 'class-transformer';

import { TransformBoolean } from '../../../shared/decorators/transform-boolean.decorator';
import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoUuidDto } from '../../../shared/modules/base/dtos/base-proto-uuid.dto';
import { TaxSettingsInterface } from '../../../shared/modules/settings/interfaces/tax-settings.interface';
import { ReservationCheckoutModeEnum } from '../../../tenant/settings/enums/reservation-checkout-mode.enum';
import { ReservationPaymentAmountEnum } from '../../../tenant/settings/enums/reservation-payment-amount.enum';
import { TenantSettingsDiscountsDto } from '../../../tenant/settings/dtos/tenant-settings-discounts.dto';
import { TenantSettingsReservationPercentageDepositRoundingDto } from '../../../tenant/settings/dtos/tenant-settings-reservation-percentage-deposit-rounding.dto';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';

/**
 * Proto tenant settings DTO
 * @description
 * IMPORTANT: This DTO must not contain any sensitive data like API keys, passwords, contact information, etc.
 * It is exposed to the client on an API endpoint that is not protected by authentication for READ access.
 */
@CaslSubject(AppSubjectEnum.TENANT_SETTINGS)
export class ProtoTenantSettingsDto
  extends BaseProtoUuidDto
  implements TaxSettingsInterface
{
  @TransformInt()
  availabilityThreshold?: number;
  logoUri?: string;
  timezone?: string;

  reservationMode?: ReservationCheckoutModeEnum;
  currencyIsoCode?: string;

  /**
   * Controls how much to charge or pre-authorize when initializing a reservation
   * payment (none, deposit, or full amount).
   */
  reservationPaymentAmount?: ReservationPaymentAmountEnum;

  @Type(() => TenantSettingsReservationPercentageDepositRoundingDto)
  reservationPercentageDepositRounding?: TenantSettingsReservationPercentageDepositRoundingDto;

  @Type(() => TenantSettingsDiscountsDto)
  discounts?: TenantSettingsDiscountsDto;

  // Tax settings
  @TransformBoolean()
  isTaxIncluded?: boolean;
  defaultTaxRateType?: TaxRateTypeEnum;

  @TransformFloat()
  standardTaxRate?: number;
  @TransformFloat()
  exemptTaxRate?: number;
  @TransformFloat()
  zeroTaxRate?: number;
  @TransformFloat()
  reducedTaxRate1?: number;
  @TransformFloat()
  reducedTaxRate2?: number;
  @TransformFloat()
  reducedTaxRate3?: number;
  @TransformFloat()
  reverseChargeTaxRate?: number;

  standardTaxRateLabel?: string;
  exemptTaxRateLabel?: string;
  zeroTaxRateLabel?: string;
  reducedTaxRate1Label?: string;
  reducedTaxRate2Label?: string;
  reducedTaxRate3Label?: string;
  reverseChargeTaxRateLabel?: string;

  paymentProviders?: {
    apiPaymentBaseUrl?: string;
  };
}
